import { render, staticRenderFns } from "./ActivityGame.vue?vue&type=template&id=3689713c&"
import script from "./ActivityGame.vue?vue&type=script&lang=js&"
export * from "./ActivityGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports